const SCHEDULE = 'Schedule';
const CONTRACT = 'Contract';
const PATTERN = 'Pattern';
const FIXED = 'Fixed';

export default Object.freeze({
    [SCHEDULE]: -1,
    [CONTRACT]: -2,
    [PATTERN]: -3,
    [FIXED]: -4,
});
